const AceHighwayMedpidApiUrls = {
    SUBMIT_ACE_CREW: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/medpid/submitAceCrew`,
    SUBMIT_ACE_EQUIPMENT: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/medpid/submitAceEquipment`,
    SUBMIT_ACE_CONVEYANCE: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/medpid/submitAceConveyance`,
  };
  
  export default AceHighwayMedpidApiUrls
  